import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4.75 15V18C4.75 18.6904 5.30964 19.25 6 19.25H9" vectorEffect="non-scaling-stroke" />
		<Path opacity=".25" d="M19.25 9V6C19.25 5.30964 18.6904 4.75 18 4.75H15M19.25 15V18C19.25 18.6904 18.6904 19.25 18 19.25H15M9 4.75H6C5.30964 4.75 4.75 5.30964 4.75 6V9" vectorEffect="non-scaling-stroke" />
	</SVG>
);
